export default __webpack_public_path__ + "static/media/user_icon.f722aec3.svg";